<template>
  <div>
    <h6>{{ MAIL }}</h6>
    <vs-divider style="margin: 0px !important"></vs-divider>
    Kay: {{ GUIDKOD }}
    <vs-divider style="margin: 0px !important"></vs-divider> Onay Zamanı:
    <span style="color: #ea5455">{{ ONAYZAMAN }}</span>
  </div>
</template>
<script>
import { BBadge } from "bootstrap-vue";
export default {
  components: {
    BBadge,
  },
  data() {
    return {
      MAIL: "",
      GUIDKOD: "",
      ONAYZAMAN: "",
    };
  },
  methods: {
    gelenData() {
      this.MAIL = this.params.data.MAIL;
      this.GUIDKOD = this.params.data.GUIDKOD;
      this.ONAYZAMAN = this.params.data.ONAYZAMAN;
    },
  },
  created() {
    this.gelenData();
  },
};
</script>
